import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth.js';
import { Cargador } from '../ui/Cargador.jsx';

/**
 * Rutas que exigen sesión.
 *
 * Lo importante aquí es el caso `cargando`: mientras se comprueba la sesión NO se
 * redirige a /login. Si se redirigiera, cada recarga expulsaría brevemente a
 * quien sí ha iniciado sesión y vería el formulario de login parpadear.
 *
 * Se espera primero y se decide después.
 */
export function ProtectedRoute() {
  const { estado } = useAuth();
  const location = useLocation();

  if (estado === 'cargando') {
    return <Cargador texto="Comprobando tu sesión" />;
  }

  if (estado === 'anonimo') {
    // `state.from` guarda a dónde quería ir el usuario. Sin esto, al iniciar
    // sesión vuelve a la home y pierde el paso que estaba a punto de hacer.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

/**
 * Rutas solo para gente que NO ha iniciado sesión.
 *
 * Sin esto, quien ya tiene sesión puede abrir /login y ver el formulario; al
 * enviarlo, el servidor responde 409 y la página parece rota.
 */
export function AnonymousRoute() {
  const { estado } = useAuth();

  if (estado === 'cargando') {
    return <Cargador texto="Comprobando tu sesión" />;
  }

  if (estado === 'autenticado') {
    return <Navigate to="/panel" replace />;
  }

  return <Outlet />;
}
